/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentTemplate from './treatment-template';
import TreatmentTemplateDetail from './treatment-template-detail';
import TreatmentTemplateUpdate from './treatment-template-update';
import TreatmentTemplateDeleteDialog from './treatment-template-delete-dialog';

const TreatmentTemplateRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentTemplate />} />
    <Route path="new" element={<TreatmentTemplateUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentTemplateDetail />} />
      <Route path="edit" element={<TreatmentTemplateUpdate />} />
      <Route path="delete" element={<TreatmentTemplateDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentTemplateRoutes;
